import React from 'react';

interface IuseFormArgs<Initial> {
  initialValues: Initial;
}

type InputOptions = string | boolean | number;

type SimpleFormEvent = {
  target: { value: InputOptions; name: string };
};
interface IuseFormReturn<Initial> {
  values: Initial;
  handleChange: (
    e:
      | React.ChangeEvent<
          HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement
        >
      | SimpleFormEvent,
  ) => void;
}

const useForm = <Initial>({
  initialValues,
}: IuseFormArgs<Initial>): IuseFormReturn<Initial> => {
  const [values, setValues] = React.useState<Initial>(initialValues);

  const handleChange = (
    event:
      | React.ChangeEvent<
          HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement
        >
      | SimpleFormEvent,
  ) => {
    const { target } = event;
    const { name, value } = target;
    setValues({ ...values, [name]: value });
  };

  return { values, handleChange };
};

export default useForm;
